import React from 'react';
import {
    FreeTextArea,
    LanguagePicker
} from '../../../Inputs/Inputs';
import { Typography, Grid, Box } from '@mui/material';
import ClientCard from './ClientCard';
import { ClientLifeStageOptionPicker, DISCPicker } from '../../../Inputs/Inputs';

export const MeetingNoteForm = ({
    intl,
    inputOptions,
    onValueChange,
    onTraitsChange,
    client,
    children
}) => {
    return (
        <>
            <Typography variant="body2">
                {intl.formatMessage({ id: 'chat-gpt-options-lazy-packs-meeting-notes-desc' })}
            </Typography>
            {
                client && <ClientCard client={client} intl={intl}>
                    <ClientLifeStageOptionPicker
                        intl={intl}
                        options={inputOptions}
                        onValueChange={onValueChange}
                    />

                    <DISCPicker
                        intl={intl}
                        inputOptions={inputOptions}
                        onTraitsChange={onTraitsChange}
                    />
                </ClientCard>
            }

            <FreeTextArea
                intl={intl}
                value={inputOptions.remark || ''}
                onChange={(_, newValue) => onValueChange('remark', newValue)}
            />

            <LanguagePicker intl={intl} options={inputOptions} onValueChange={onValueChange} />
            {children}
        </>
    );
};

export default MeetingNoteForm;
